// extracted by mini-css-extract-plugin
export default {"label":"Search_label__LmlUh","input":"Search_input__UtK32"};